import React, { CSSProperties, FC, MouseEventHandler, useRef } from 'react'

import { getStyledElementProps } from '@/utils'
import {
  WidgetAccordeonCardProps,
  WidgetAccordeonCardBodyProps,
} from './widget-accordeon-card.d'

import styles from './widget-accordeon-card.module.scss'

import { WidgetIcon } from '@/atoms'

export const WidgetAccordeonCardBody: FC<WidgetAccordeonCardBodyProps> = (
  props
) => {
  const styledProps = getStyledElementProps(props, styles['body'])
  return <div {...styledProps} />
}

export const WidgetAccordeonCard: FC<WidgetAccordeonCardProps> = ({
  title,
  iconName,
  iconColor,
  padding,
  children,
}) => {
  const mainWrapperEl = useRef<HTMLDivElement>(null)
  const handleClick: MouseEventHandler<HTMLDivElement> = () => {
    mainWrapperEl.current?.classList.toggle(styles['expanded'])
  }
  const customClass: CSSProperties = {}

  return (
    <div ref={mainWrapperEl} onClick={handleClick}>
      <div className={styles['root']} style={customClass}>
        <div className={styles['header-container']}>
          <div className={styles['left']}>
            <WidgetIcon name={iconName} color={iconColor} padding={padding} />
            <span className={styles['title']}>{title}</span>
          </div>
          <div className={styles['caret-icon']}>
            <WidgetIcon name={'chevronDown'} color={iconColor} />
          </div>
        </div>
        {children}
      </div>
    </div>
  )
}
